import { createContext } from 'react';
import { TrainingSession, TrainingFormValues, TimePeriod } from '../types';

export interface TrainingJournalContextProps {
  sessions: TrainingSession[] | null;
  selectedTimePeriod: TimePeriod;
  addSession: (session: TrainingFormValues) => Promise<TrainingSession | null>;
  editSession: (id: string, updates: TrainingFormValues) => Promise<TrainingSession | null>;
  deleteSession: (id: string) => Promise<boolean>;
  isLoading: boolean;
  error: string | null;
  refreshSessions: () => void;
  setSelectedTimePeriod: (period: TimePeriod) => void;
}

export const TrainingJournalContext = createContext<
  TrainingJournalContextProps | undefined
>(undefined);
